<template lang="html">
  <div class="peer-assessment-questions">
    <p class="pl-subheading">Peer Feedback Questions</p>

    <ul
      class="question-list-item"
      v-for="(question, index) in getCurrentRT.peer_assessment_questions"
    >
      <li class="row middle-xs" style="padding-left: 16px; min-height: 60px">
        <span
          class="col-xs-8 pl-body-2"
          v-if="editing_question_index !== index || !editing_question"
        >
          {{ index + 1 }}. {{ question.question }}
        </span>
        <div
          class="col-xs-8 pl-body-2 flex"
          v-if="editing_question && editing_question_index === index"
        >
          <span> {{ index + 1 }}. </span>
          <input
            ref="edit-question"
            class="edit-rt-question-input"
            @blur="savePeerQuestion()"
            v-model="peer_assessment_questions[editing_question_index].question"
          />
        </div>
        <div class="col-xs-2 tc">
          <toggle-button
            @change="toggleQuestionStatus($event, index)"
            :value="question.is_active"
            color="#72ccd7"
            :labels="true"
          />
        </div>
        <div class="col-xs-1">
          <!-- Edit question button -->
          <pl-button class="pl-icon" @click.native="editPeerQuestion(index)">
            <i class="fas fa-pencil-alt" aria-hidden="true" />
          </pl-button>
        </div>
        <!-- Only custom created questions can be deleted  -->
        <div v-if="question.is_custom" class="col-xs-1">
          <!-- delete question button -->
          <pl-button class="pl-icon" @click.native="removePeerQuestion(index)">
            <i class="fa fa-times" aria-hidden="true" />
          </pl-button>
        </div>
      </li>
    </ul>

    <!-- ADD GUIDANCE QUESTIONS -->
    <div class="add-list-container" style="padding: 13px 0">
      <div class="row middle-xs" style="padding-left: 9px">
        <pl-input
          type="text"
          labelText="Question"
          v-model="peer_question_new"
          class="col-xs-10"
        />
        <pl-button class="pl-primary pl-icon" @click.native="addPeerQuestion">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </pl-button>
      </div>
    </div>
    <div class="row end-xs close-button">
      <pl-button @click.native="$emit('closeTab')"> Close </pl-button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        peer_question_new: '',
        peer_assessment_description:
          'Ask your students guiding questions as they \n' +
          'provide stimulating comments (and possibly \n' +
          'unsolicited advice) to their peers.',
        peer_assessment_questions: [],
        editing_question_index: 0,
        editing_question: false,
      };
    },
    computed: {
      ...mapGetters(['getCurrentRT']),
    },
    methods: {
      addPeerQuestion() {
        if (!this.peer_question_new) {
          return;
        }
        const { peer_assessment_questions } = this.getCurrentRT;
        const cloned_peer_questions = JSON.parse(
          JSON.stringify(peer_assessment_questions)
        );
        cloned_peer_questions.push({
          question: this.peer_question_new,
          is_active: true,
          is_custom: true,
        });
        this.$store.dispatch(
          'analytics',
          'edit written roundtable - change peer guidance question'
        );
        this.$store
          .dispatch('savingRTDetails', {
            peer_assessment_questions: cloned_peer_questions,
            id: this.getCurrentRT.id,
          })
          .then(() => {
            this.peer_question_new = '';
          });
      },
      removePeerQuestion(index) {
        const { peer_assessment_questions } = this.getCurrentRT;
        const cloned_peer_questions = JSON.parse(
          JSON.stringify(peer_assessment_questions)
        );
        cloned_peer_questions.splice(index, 1);
        this.$store.dispatch('savingRTDetails', {
          peer_assessment_questions: cloned_peer_questions,
          id: this.getCurrentRT.id,
        });
      },
      toggleQuestionStatus(event, index) {
        const { value } = event;
        const { peer_assessment_questions } = this.getCurrentRT;
        const cloned_peer_questions = JSON.parse(
          JSON.stringify(peer_assessment_questions)
        );
        cloned_peer_questions[index].is_active = value;
        this.$store.dispatch('savingRTDetails', {
          peer_assessment_questions: cloned_peer_questions,
          id: this.getCurrentRT.id,
        });
      },
      editPeerQuestion(index) {
        this.peer_assessment_questions =
          this.getCurrentRT.peer_assessment_questions;
        this.editing_question_index = index;
        this.editing_question = true;
      },
      savePeerQuestion() {
        const payload = {
          peer_assessment_questions: this.peer_assessment_questions,
        };
        payload.id = this.getCurrentRT.id;
        this.$store
          .dispatch('savingRTDetails', payload)
          .then(() => (this.editing_question = false));
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus'
    .close-button
      border-top: 2px solid pl-fog;
      padding: 15px 0;

    .fa-info-circle
      font-size: 12px

    .question-list-item
      list-style: none
      margin: 0
      padding: 0

    .edit-question-container
      min-width: 65%
      span, .edit-rt-question-input
        padding: 6px
        font-size: 14px

    .edit-rt-question-input
      position: relative
      width: 100%
      outline: none
      border: 2px solid #e1e8ee
      border-radius: 5px
      &:focus
        border-color: pl-primary
</style>



// WEBPACK FOOTER //
// guidanceQuestionsSettingsTab.vue?3da845fb